/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as SlugIndexRouteImport } from './routes/$slug/index'
import { Route as SlugAdminRouteImport } from './routes/$slug/admin'
import { Route as CoreAdminRouteImport } from './routes/core.admin'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugIndexRoute = SlugIndexRouteImport.update({
  id: '/$slug/',
  path: '/$slug/',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugAdminRoute = SlugAdminRouteImport.update({
  id: '/$slug/admin',
  path: '/$slug/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CoreAdminRoute = CoreAdminRouteImport.update({
  id: '/core/admin',
  path: '/core/admin',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/$slug/admin': typeof SlugAdminRoute
  '/core/admin': typeof CoreAdminRoute
  '/$slug/': typeof SlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/$slug/admin': typeof SlugAdminRoute
  '/core/admin': typeof CoreAdminRoute
  '/$slug': typeof SlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/$slug/admin': typeof SlugAdminRoute
  '/core/admin': typeof CoreAdminRoute
  '/$slug/': typeof SlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/admin' | '/$slug/admin' | '/core/admin' | '/$slug/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/admin' | '/$slug/admin' | '/core/admin' | '/$slug'
  id: '__root__' | '/' | '/admin' | '/$slug/admin' | '/core/admin' | '/$slug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  SlugAdminRoute: typeof SlugAdminRoute
  CoreAdminRoute: typeof CoreAdminRoute
  SlugIndexRoute: typeof SlugIndexRoute
}

declare module '@tanstack/solid-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug/': {
      id: '/$slug/'
      path: '/$slug'
      fullPath: '/$slug/'
      preLoaderRoute: typeof SlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug/admin': {
      id: '/$slug/admin'
      path: '/$slug/admin'
      fullPath: '/$slug/admin'
      preLoaderRoute: typeof SlugAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/core/admin': {
      id: '/core/admin'
      path: '/core/admin'
      fullPath: '/core/admin'
      preLoaderRoute: typeof CoreAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  SlugAdminRoute: SlugAdminRoute,
  CoreAdminRoute: CoreAdminRoute,
  SlugIndexRoute: SlugIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
